import axios from "axios";
import { ClearSession, GetSession } from "../../Shared-ui/utils/Auth/AuthHelpers";
import { ChatBaseUrl } from "../../Constant/Setting";
import { useDispatch, useSelector } from "react-redux";
import { SetLogout } from "../../Shared-ui/Store/AuthReducer/AuthActions";
import { redirect } from "react-router-dom";

const ChatInstance = axios.create({
    baseURL: ChatBaseUrl,
    headers: {
        'Content-Type': 'application/json',
    }
})

// Set up an Axios request interceptor to add the authorization token

ChatInstance.interceptors.request.use((config) => {
    const serviceToken = GetSession()
    if (serviceToken) {
        config.headers['Authorization'] = `Bearer ${serviceToken}`;
    }
    return config
}, (error) => {
    return Promise.reject(error)
})

// Set up an Axios response interceptor to handle authentication errors and logout

ChatInstance.interceptors.response.use((response) => {
    return response
}, (error) => {
    if (error.response) {
        if (error.response.status === 401 || error.response.status === 403) {
            ClearSession()
            window.location.href = "/logout"
        }
    }
    return Promise.reject(error)
})

// multipart instance ///

export const ChatMultipartInstance = axios.create({
    baseURL: ChatBaseUrl,
    headers: {
        'Content-Type': 'multipart/form-data',
    }
})

// Set up an Axios request interceptor to add the authorization token

ChatMultipartInstance.interceptors.request.use((config) => {
    const serviceToken = GetSession()
    if (serviceToken) {
        config.headers['Authorization'] = `Bearer ${serviceToken}`;
    }
    return config
}, (error) => {
    return Promise.reject(error)
})

// Set up an Axios response interceptor to handle authentication errors and logout

ChatMultipartInstance.interceptors.response.use((response) => {
    return response
}, (error) => {
    // if (error.response) {
    //     if (error.response.status === 401 || error.response.status === 403) {
    //         ClearSession()
    //         window.location.href = "/logout"
    //     }
    // }
    return Promise.reject(error)
})


export default ChatInstance